import { Modal, Row } from 'antd';

interface ModelComponentProp {
  open: boolean;
  title: string;
  handleOk?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
  handleCancel?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
  footer: any;
  content: any;
  [key: string]: any;
}

const ModelComponent = ({
  open,
  title,
  handleOk,
  handleCancel,
  footer,
  content,
  disableBackgroundClick = true,
  ...rest
}: ModelComponentProp) => {
  return (
    <Modal
      className="model-component"
      open={open}
      title={<div style={{ margin: '0', paddingTop: '7px' }}>{title}</div>}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={footer}
      {...rest}
      maskClosable={!disableBackgroundClick}
    >
      <Row className="px-2 pt-3">{content}</Row>
    </Modal>
  );
};

export default ModelComponent;
